export const Slices = {
    Feed: 'feed',
    Search: 'search',
    Prompts: 'prompts',
} as const;
